import { paddingStyle } from "./styles.mjs";
import { useTheme } from "./ThemeProvider.mjs";
import { useStyles } from "purse-styles";
import React from "react";
import { Menu as Menu$1, MenuItem as MenuItem$1, MenuTrigger, Popover as Popover$1, SubmenuTrigger } from "react-aria-components";
import { jsx } from "react/jsx-runtime";

//#region src/Menu.tsx
function Popover({ children, shadow = true, placement }) {
	const theme = useTheme();
	const getTransform = () => {
		if (placement === "top") return "translateY(4px)";
		if (placement === "bottom") return "translateY(-4px)";
		if (placement === "left") return "translateX(4px)";
		if (placement === "right") return "translateX(-4px)";
		return "translateY(-4px)";
	};
	return /* @__PURE__ */ jsx(Popover$1, {
		className: useStyles({
			boxShadow: shadow === true ? theme.shadows.default : shadow ? theme.shadows[shadow] : void 0,
			borderRadius: theme.borderRadiuses["lg"],
			overflow: "hidden",
			background: theme.colors.background,
			transition: `opacity ${theme.transitions.fast.duration}ms ${theme.transitions.fast.easing}, transform ${theme.transitions.fast.duration}ms ${theme.transitions.fast.easing}`,
			"&[data-entering]": {
				opacity: 0,
				transform: getTransform()
			},
			"&[data-exiting]": {
				opacity: 0,
				transform: getTransform()
			},
			"@media (prefers-reduced-motion: reduce)": { transition: "none" }
		}),
		placement,
		children
	});
}
const Menu = ({ children, onAction, "aria-label": ariaLabel }) => {
	const theme = useTheme();
	return /* @__PURE__ */ jsx(Menu$1, {
		className: useStyles({
			background: theme.colors.background,
			borderRadius: theme.borderRadiuses.lg,
			boxShadow: theme.shadows.subtle,
			padding: theme.spacing.xxs,
			minWidth: 200,
			maxHeight: 400,
			overflowY: "auto",
			outline: "none"
		}),
		onAction,
		"aria-label": ariaLabel,
		children
	});
};
const MenuItem = ({ children, onAction }) => {
	const theme = useTheme();
	return /* @__PURE__ */ jsx(MenuItem$1, {
		className: useStyles(paddingStyle({
			horizontal: "xs",
			vertical: "xs"
		}), {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing.xs,
			borderRadius: theme.borderRadiuses.sm,
			color: theme.colors.sand12,
			userSelect: "none",
			cursor: "default",
			outline: "none",
			fontSize: theme.fontStyles.sm.fontSize,
			lineHeight: theme.fontStyles.sm.lineHeight,
			"&[data-hovered]": { background: theme.colors.sand3 },
			"&[data-focused]": { background: theme.colors.sand3 },
			"&[data-pressed]": { background: theme.colors.sand4 }
		}),
		onAction,
		children
	});
};

//#endregion
export { Menu, MenuItem, MenuTrigger, Popover, SubmenuTrigger };